<template>
  <Modal
    :width="560"
    name="HAUSEFUL_INVOICE_GENERATE_ASAAS_BATCH_MODAL"
    :title="$t('hausefulInvoices.modals.generateAsaasBatch.title')"
    actions
  >
    <template v-slot:body>
      <!-- Depois de emitir, o que interessa é o que NÃO saiu: as demais já sumiram de Pendentes. -->
      <div v-if="failures.length">
        <p class="body-2 error--text">
          {{ $t('hausefulInvoices.modals.generateAsaasBatch.partial', { count: failures.length }) }}
        </p>
        <v-card
          v-for="(failure, index) in failures"
          :key="index"
          class="py-3 px-4 mb-2"
          color="grey lighten-3"
          outlined
        >
          <span class="body-2 d-block font-weight-bold">
            {{ failure.realEstate }}
          </span>
          <span v-if="failure.branch" class="caption d-block grey--text">
            {{ $t('hausefulInvoices.subsidiary') }}: {{ failure.branch }}
          </span>
          <span class="caption d-block error--text mt-1">
            {{ failure.error }}
          </span>
        </v-card>
      </div>

      <div v-else>
        <p class="body-2">
          {{ $t('hausefulInvoices.modals.generateAsaasBatch.message') }}
        </p>
        <v-card class="py-4 px-4 my-3" color="grey lighten-3" outlined>
          <h6 class="text-uppercase grey--text">
            {{ $t('hausefulInvoices.modals.generateAsaasBatch.selected') }}
          </h6>
          <span class="body-2 d-block">
            {{ $t('hausefulInvoices.selectedCount', { count: selectedHausefulInvoices.length }) }}
          </span>
          <span class="body-2 d-block success--text font-weight-bold mt-2">
            {{ $t('hausefulInvoices.total') }}: {{ totalAmount }}
          </span>
        </v-card>
      </div>
    </template>
    <template v-slot:actions>
      <v-btn
        @click="closeAllModals"
        :disabled="isLoading"
        class="grey--text"
        elevation="0"
        text
      >
        {{ failures.length
          ? $t('hausefulInvoices.modals.defaultActions.close')
          : $t('hausefulInvoices.modals.defaultActions.cancel') }}
      </v-btn>
      <v-btn
        v-if="!failures.length"
        @click="generateInvoices"
        :loading="isLoading"
        elevation="0"
        class="ml-5"
        color="primary"
      >
        {{ $t('hausefulInvoices.modals.generateAsaasBatch.action') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

import Modal from '@/components/app/Modal'
import { catalogMonetary } from '@/util/catalog'

export default {
  name: 'ModalHausefulInvoiceGenerateAsaasBatch',

  components: {
    Modal,
  },

  computed: {
    ...mapGetters([
      'isLoading',
      'selectedHausefulInvoices',
      'selectedHausefulInvoicesTotal',
      'hausefulInvoiceBatchFailures',
    ]),

    failures() {
      return this.hausefulInvoiceBatchFailures
    },

    totalAmount() {
      return catalogMonetary(this.selectedHausefulInvoicesTotal)
    },
  },

  methods: {
    ...mapActions(['generateAsaasHausefulInvoicesBatch']),
    ...mapMutations(['closeAllModals']),

    generateInvoices() {
      this.generateAsaasHausefulInvoicesBatch()
    },
  },
}
</script>
